import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { useAddBookMutation } from '../../features/apiSlice/apiSlice';

const AddBook = () => {
    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm();
    const [addBook, { isLoading, isSuccess, isError }] = useAddBookMutation();
    const navigate = useNavigate()
    const onSubmit = data => {
        addBook(data)
    }

    useEffect(() => {
        if (isSuccess) {
            navigate('/')
        }
        if (isError) {
            alert("Error try again")
        }
    }, [isSuccess, isError, reset])

    return (
        <main className="py-6 2xl:px-6">
            <div className="container">
                <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                    <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
                    <form onSubmit={handleSubmit(onSubmit)} className="book-form">
                        <div className="space-y-2">
                            <label for="lws-bookName">Book Name</label>
                            <input required className="text-input" type="text" id="lws-bookName" name="name" {...register("name", { required: true })} />
                        </div>

                        <div className="space-y-2">
                            <label for="lws-author">Author</label>
                            <input required className="text-input" type="text" id="lws-author" name="author" {...register("author", { required: true })} />
                        </div>

                        <div className="space-y-2">
                            <label for="lws-thumbnail">Image Url</label>
                            <input required className="text-input" type="text" id="lws-thumbnail" name="thumbnail"  {...register("thumbnail", { required: true })} />
                        </div>

                        <div className="grid grid-cols-2 gap-8 pb-4">
                            <div className="space-y-2">
                                <label for="lws-price">Price</label>
                                <input required className="text-input" type="number" step='any' id="lws-price" name="price" {...register("price", { required: true })} />
                            </div>

                            <div className="space-y-2">
                                <label for="lws-rating">Rating</label>
                                <input required className="text-input" type="number" id="lws-rating" name="rating" min="1"
                                    max="5"  {...register("rating", { required: true })} />
                            </div>
                        </div>

                        <div className="flex items-center">
                            <input id="lws-featured" type="checkbox" name="featured" className="w-4 h-4"  {...register("featured")} />
                            <label for="lws-featured" className="ml-2 text-sm"> This is a featured book </label>
                        </div>

                        <button disabled={isLoading} type="submit" className="submit" id="lws-submit">Add Book</button>
                    </form>
                </div>
            </div>
        </main>
    );
};

export default AddBook;